import React from 'react';

const LayoutMain = ({ id, children, className }) => {
  return (
    <div id={id || 'layout-main'} className={`max-w-main w-full mx-auto bg-white py-6 px-8 ${className || ''}`}>
      {children}
    </div>
  );
};

export default React.memo(LayoutMain);
